import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import UnstyledCollectionList from '../components/CollectionList';
import Table from '../components/Table';
import dataStore from '../models/dataStore';
import useCollectionQueries from '../utils/useCollectionQueries';
const Wrapper = styled.div `
  display: grid;
  grid-template-areas: 'list items';
  grid-template-columns: 200px 1fr;
  overflow: hidden;
  height: 100%;
`;
const CollectionList = styled(UnstyledCollectionList) `
  grid-area: list;
`;
const Items = styled(Table) `
  grid-area: items;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
`;
const Queries = () => {
    const [collectionName, setCollectionName] = useState();
    const collectionsItem = dataStore.useItem('collections');
    const collection = useMemo(() => collectionsItem?.items.find(c => c.name === collectionName), [collectionsItem, collectionName]);
    const items = useCollectionQueries(collectionName || '');
    const queries = useMemo(() => items.map(item => ({
        id: item.id,
        count: item.count.toString(),
        selector: JSON.stringify(item.selector, null, 2),
        options: JSON.stringify(item.options, null, 2),
        lastTime: item.lastTime.toLocaleString(),
    })), [items]);
    return (_jsxs(Wrapper, { children: [_jsx(CollectionList, { value: collectionName, onChange: name => setCollectionName(name) }), collection
                ? (_jsx(Items, { items: queries, columns: [{
                            name: 'lastTime',
                            label: 'Last Exec',
                        }, {
                            name: 'count',
                            label: 'Count',
                        }, {
                            name: 'selector',
                            label: 'Selector',
                        }, {
                            name: 'options',
                            label: 'Options',
                        }] }))
                : (_jsx(Items, { items: [], columns: [], placeholder: "Select a collection on the left" }))] }));
};
export default Queries;
